import "slick-carousel/slick/slick";
import "slick-carousel/slick/slick.scss";

export function slider() {
	if ($("#headerslider .image").length > 1) {
		$("#headerslider").not('.slick-initialized').slick({
			infinite: true,
			arrows: false,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 3000,
			fade: true,
		});
	}

	if ($("#footerslider .sliderinner .slideritem").length > 1) {
		$("#footerslider .sliderinner").not('.slick-initialized').slick({
			infinite: true,
			arrows: false,
			dots: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			speed: 2000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 544,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}
}
